<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-10 10:04:51
 * @LastEditors: xgx
 * @LastEditTime: 2023-07-05 16:25:27
-->
<template>
    <el-drawer
        title="上传文件"
        :visible.sync="visibleTwo"
        @closed="close"
        :size="width<=720?'90%':'500px'"
        :with-header="true"
        class="box"
    >
        <el-form ref="ruleForm" label-width="100px" class="demo-ruleForm" >
        <div class="file-paths">
            <div class="title-box">
                <i class="el-icon-info icon-title"></i>
                <div style="margin-left:8px">在 {{directoryPath}} 路径下上传文件</div>
            </div>
        </div>
        <div style="margin:20px 0;display: flex;">
            <a-upload :showUploadList="false" directory :custom-request="customFiles">
                <el-button size="small" type="primary">上传文件夹</el-button>
            </a-upload>
            <a-upload multiple :showUploadList="false" :custom-request="customFiles" style="margin-left:20px">
                <el-button size="small" type="primary">上传文件</el-button>
            </a-upload>
        </div>
        <div class="upload-box">
                <div v-for="(item,index) in fileList" class="upload-one">
                    <div class="upload-one-left">
                        <div style="display:flex;">
                              <div class="icon-box"><span class="icon-description"></span></div>
                            <div>{{item.fileName}}</div>
                        </div>
                        <div class="icon-del">
                            <span class="file-succes" v-if="item.isSuccess">成功</span>
                            <span class="file-error" v-if="!item.isSuccess">失败</span>
                        </div>
                    </div>
                    <div class="file-error" v-if="!item.isSuccess">{{item.message}}</div>
                </div>
        </div>
    </el-form>
    <div class="form-bottom">
          <el-button type="primary" style="padding: 10px 24px" size="medium" @click="close"
            >关 闭</el-button
          >
        </div>
  </el-drawer>
</template>

<script>
import { uploadTemplate } from "./template_management.js";
import axios from "axios";
export default {
  data() {
    return {
      fileList: [],
      width:'',
      visibleTwo:false,
    };
  },
    props:{
        visible:{
            type:Boolean,
            default:false,
        },
        directoryPath:{
            type:String,
            default:'',
        }
    },
    watch:{
        visible(){
             this.visibleTwo = this.visible;
             if(this.visibleTwo){
                this.fileList = [];
                 this.width  = document.documentElement.clientWidth;
                window.onresize = () => {
                    return (() => {
                        this.width  = document.documentElement.clientWidth;
                    })();
                    };
             }
             
        }
    },
    methods: {
        close() {
            this.$emit("close");
            //this.$emit("refresh",{path:_this.directoryPath});
        },
        beforeUpload(file) {
            this.fileList = [...this.fileList,file];
            return false;
        },
        beforeUploadFile(file){
            this.fileList = [...this.fileList,file]
            return false
        },
        customFiles(options){
                let formData = new FormData(); 
                let file = options.file;
                formData.append("files",file);
                formData.append('path',this.directoryPath);
                let _this = this;
                this.upload(formData).then((res)=>{
                    if(res.code == 0){
                         _this.fileList.push(res.data[0]);
                    }
                })
        },
        handleUpload() {
            const _this = this;
            let formData = new FormData();
            _this.fileList.forEach((file) => {
                formData.append("files",  file);
            });
            formData.append('path', this.directoryPath)
            this.upload(formData)
        },
        async upload(formData){
           return await uploadTemplate(formData).then(res=>{
                if(res.code == 0){
                    return res;
                    //this.close()
                }
            })
        }
    },
    created() {
        console.log(this.visible, "ssss");
    },
};
</script>

<style lang="less" scoped>
    /deep/ .el-drawer__header {
        border-bottom: solid 1px #ededef;
        padding-bottom: 24px;
        color: #000;
        font-size: 18px;
        font-weight: 600;
    }
    /deep/ .el-icon-close {
        font-weight: 600;
    }
    .demo-ruleForm {
        padding: 24px;
        padding-top: 0px;
    }
    .file-paths {
        background: #f5f5f5;
        padding: 5px;
    }
    .bottom {
        text-align: right;
        position: absolute;
        bottom: 0;
        height: 60px;
        border-top: solid 1px #e5e7ec;
        width: 100%;
        .form-bottom {
            border-top: solid 1px #e5e7ec;
            padding: 14px 0px;
            text-align: right;
            padding-right: 14px;
            position: absolute;
            width: 100%;
            bottom: 0;
            background: #fff;
        }
    }
    .upload-one-left{
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 16px;
        color: #1890ff;
    }
    .icon-box{
        margin-top: 6px;
        margin-right: 6px;
    }
    .icon-description:before{
        color: #1890ff;
    }
    .file-error{
        font-size: 12px;
        margin-top: 5px;
        color: red;
    }
    .upload-one{
        margin-bottom: 10px;
    }
    .icon-del{
        cursor: pointer;
        padding-right: 10px;
    }
    .file-succes{
         font-size: 12px;
         color: #1890ff;
    }
    .upload-box{
        padding-bottom: 60px;
        overflow: auto;
        height: 634px
    }
    .el-button--primary {
  background: #176de6;
}
.title-box {
  display: flex;
  border-radius: 4px;
  background-color: rgba(244, 244, 245, 1);
  padding: 2px 10px;
  color: rgba(144, 147, 153, 1);
  font-size: 13px;
  text-align: left;
  font-family: HarmonyOS_Sans_SC-regular;
  .icon-title {
    color: #a9aab1;
    transform: rotate(-13deg);
    margin-top: 3px;
    margin-right: 2px;
  }
  /deep/ .anticon-close {
    color: rgba(48, 49, 51, 1);
    font-size: 20px;
    font-weight: bold;
  }
}
@media screen and (max-width: 720px) {
    .upload-box{
        height: 65vh !important;
    }
}
</style>